<phx-alert
  phxAlertType="toast"
  [phxAlertIntent]="phxToastInstance.type"
  [phxOrientation]="phxToastInstance.options.phxContentOrientation"
  [phxClosable]="phxToastInstance.options.phxClosable"
  [phxHasIcon]="phxToastInstance.options.phxHasIcon"
  [phxIcon]="phxToastInstance.options.phxIcon"
  (phxOnClose)="onCloseButtonClicked()"
  [@moveUpMotion]="phxToastInstance.state"
  (@moveUpMotion.done)="onAnimationEnd($event)"
  (mouseenter)="onEnter()"
  (mouseleave)="onLeave()"
>
  <span *ngIf="phxToastInstance.toastData?.title" phx-alert-title>{{ phxToastInstance.toastData.title }}</span>
  <div phx-alert-content>
    <ng-container *ngIf="isContentTemplate" [ngTemplateOutlet]="$any(phxToastInstance.toastData.content)"></ng-container>
    <span *ngIf="!isContentTemplate">{{ phxToastInstance.toastData.content }}</span>
  </div>
  <div *ngIf="phxToastInstance.toastData?.actions" phx-alert-actions>
    <ng-container [ngTemplateOutlet]="phxToastInstance.toastData.actions"></ng-container>
  </div>
</phx-alert>